















































import {Component, Mixins, Prop, Vue} from 'vue-property-decorator'
import ItDateInput from '@/components/itrack/ItDateInput.vue'
import DeliverySacPublicRequest from '@/model/request/DeliverySacPublicRequest'
import {IResource} from 'simpli-web-sdk'
import {MixinMember} from '@/components/mixins/MixinMember'

@Component({components: {ItDateInput}})
  export default class FilterDeliverySacPublic extends Mixins(MixinMember) {
    @Prop({required: true}) value!: DeliverySacPublicRequest

    allDocsEvent(item: IResource, cache: IResource[]) {
      this.value.populateAllDocs(cache)
    }

    cleanDocs() {
      this.value.cleanDocs()
    }
  }
